import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from 'src/app/services/http.service';

@Injectable({ providedIn: 'root' })
export class OpenTradeHttpService extends HttpService {
  getCurrencyFilterData(): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}currencies`);
  }

  getAcquisitionRSA(payload: {
    status?: 'active' | 'expired' | 'rejected';
    originatorId?: string;
    debtorId?: string;
    creditorId?: string;
  }): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}acquisition/rsa`, {
      params: this.queryCleaner(payload),
    });
  }

  getEtrRSA(payload: {
    status?: 'active' | 'expired' | 'rejected';
    originatorId?: string;
    debtorId?: string;
    creditorId?: string;
  }): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}etr/rsa`, {
      params: this.queryCleaner(payload),
    });
  }
}
